import { patientBffApi } from '@/modules/baseApi';
import {
  Hospital,
  HospitalListDto,
  ID,
  unwrapApiErrorDetails,
  QueryFilters
} from '@ianesthesie-kit/services';
import { HospitalService } from './hospital.service';
import { useCallback } from 'react';

export const hospitalApi = patientBffApi.injectEndpoints({
  overrideExisting: false,
  endpoints: (builder) => ({
    hospitalList: builder.query<HospitalListDto[], QueryFilters | void>({
      queryFn: (filters) =>
        HospitalService.getInstance()
          .fetchAllDtos({
            pageSize: 2000,
            sort: 'name',
            ...filters
          })
          .then((r) => ({
            data: r.data
          }))
          .catch((err) => ({
            error: unwrapApiErrorDetails(err) || err
          }))
    }),

    hospitalById: builder.query<Hospital, ID>({
      queryFn: (id) =>
        HospitalService.getInstance()
          .fetchById(id)
          .then((r) => ({
            data: r.data
          }))
          .catch((err) => ({
            error: unwrapApiErrorDetails(err) || err
          }))
    })
  })
});

export const {
  useHospitalByIdQuery: useHospitalById,
  useHospitalListQuery: useHospitals
} = hospitalApi;

export const useHospitalByIdentifier = (identifier: string | undefined) => {
  const selectByIdentifier = useCallback(
    <R extends { data?: HospitalListDto[]; currentData?: HospitalListDto[] }>(
      result: R
    ) => {
      const { data, currentData, ...rest } = result;
      return {
        ...rest,
        data: data?.find((h) => h.externalIdentifier === identifier),
        currentData: currentData?.find(
          (h) => h.externalIdentifier === identifier
        )
      };
    },
    [identifier]
  );
  return useHospitals(undefined, {
    skip: !identifier,
    selectFromResult: selectByIdentifier
  });
};
